
import Vue from "vue";
import {CustomButton} from "@/utils/buttons/custom-button";
import {AuthService, BookYearService} from "@/services";
import { processIframeUrl } from "@/utils/iframe";

export default Vue.extend({
	data(){
		return {
			showModal: false,
			childOrigin: ""
		};
	},
	props: {
		button: {
			type: Object as () => CustomButton,
			required: true
		},
		value: {
			type: Boolean,
			default: false
		},
		model: {
			type: Array as () => any[],
			required: false,
		},
	},
	computed: {
		computedUrl():string{
			return processIframeUrl(this.button.Url, {
				useElectronServerAsProxy: this.button.UseDesktopAppAsProxy
			});
		}
	},
	watch: {
		value(val: boolean){
			this.showModal = val;
		},
		showModal(val: boolean){
			this.$emit("input", val);
		}
	},
	methods: {
		close(){
			this.showModal = false;
		},
		sendAppData(frame: HTMLIFrameElement) {
			if (!this.childOrigin) return;
			let app = {
				bookyear: BookYearService.selectedBookYear,
				dossier: AuthService.wfDossier.id,
				userId: AuthService.wfUser.ID,
				accessToken: AuthService.tokenStore.getSelectedToken().token,
				socketId: AuthService.tokenStore.socketId
			};
			frame.contentWindow?.postMessage({data: this.model, app}, this.childOrigin);
		},
		async onMessage(e: MessageEvent){
			if (e.data?.type === "IFRAME_READY") {
				this.childOrigin = e.origin;
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					setTimeout(()=>{
						this.sendAppData(frame);
					},150);
				}
			}

			if (e.data?.type === "REQUEST_TOKEN") {
				await AuthService.refreshTokensIfRequired();
				let frame = this.$refs.frame as HTMLIFrameElement;
				if(frame){
					this.sendAppData(frame);
				}
			}

			if (e.data?.type === "IFRAME_UPDATE") {
				this.$emit("update-parent",e.data?.data);
			}

			if (e.data?.type === "CLOSE_MODAL") {
				this.close();
			}
		},
	},
	mounted(){
		this.showModal = this.value;
		window.addEventListener("message", (e) => {
			this.onMessage(e);
		});
	},
	beforeDestroy() {
		window.removeEventListener("message", this.onMessage);
	}
});
